import { render } from "./CampaignListPage.vue?vue&type=template&id=63b03a4c"
import script from "./CampaignListPage.vue?vue&type=script&lang=js"
export * from "./CampaignListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__